import { isValidPhoneBr } from '@/utils/phone'
import type { VerificationChannel } from '@/utils/signupVerificationApi'

/**
 * Decisão do passo 3 (celular), separada da tela para ser testável: o que o
 * botão faz depende do celular, dos canais exigidos e do que já foi
 * confirmado. Quem executa (BFF, Auth0) é a tela.
 */
export type PhoneStepState = {
  phone: string
  /** Canais que o BFF exige; vazio quando nenhum OTP é pedido. */
  required: VerificationChannel[]
  /** Canais com código já enviado nesta sessão. */
  sent: VerificationChannel[]
  /** Canais já confirmados nesta sessão. */
  confirmed: VerificationChannel[]
  /** Token de verificação já emitido pelo BFF, se houver. */
  token: string
}

export type PhoneStepAction =
  /** Celular fora de 10–11 dígitos nacionais: erro no passo, sem rede. */
  | 'invalid_phone'
  /** SMS exigido e ainda sem código: pedir o envio. */
  | 'send_code'
  /** SMS exigido, código enviado e não confirmado: conferir o código. */
  | 'confirm_code'
  /** Fechar no BFF (valida CPF/e-mail/celular e emite o token) e só então seguir. */
  | 'close'
  /** Token em mãos: seguir direto para o Auth0. */
  | 'continue'

export function planPhoneSubmit(state: PhoneStepState): PhoneStepAction {
  if (!isValidPhoneBr(state.phone)) return 'invalid_phone'

  if (state.required.includes('sms') && !state.confirmed.includes('sms')) {
    return state.sent.includes('sms') ? 'confirm_code' : 'send_code'
  }

  // Sem canal pendente, o fechamento acontece aqui mesmo com nenhum canal
  // exigido: é o BFF quem valida a identidade antes de a jornada avançar.
  // Com canal confirmado, o token já prende a identidade à sessão (corrigir
  // o contato passa por `resetVerification`) e vale direto. Sem canal, um
  // token em mãos pode ser de um envio anterior com outros dados — o
  // fechamento é refeito e o token novo sobrescreve o antigo.
  return state.token && state.required.length > 0 ? 'continue' : 'close'
}
